import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 396.667 396.667" {...props}><path d="M17 87.833h362.667c9.35 0 17-7.65 17-17s-7.65-17-17-17H17c-9.35 0-17 7.65-17 17s7.65 17 17 17zM17 215.333h362.667c9.35 0 17-7.65 17-17s-7.65-17-17-17H17c-9.35 0-17 7.65-17 17s7.65 17 17 17zM17 342.833h362.667c9.35 0 17-7.65 17-17s-7.65-17-17-17H17c-9.35 0-17 7.65-17 17s7.65 17 17 17z" /></svg>);